import { store } from '../index'
import { intParser } from '../Components/Workspace/Calculation/Editors/shared'
import { UnitConfig } from '../Components/Workspace/Calculation/Inputs/UnitInput'
const tooltips = require('../Components/Shared/tooltips.json')

export const getLocation = () => {
  if (store) {
    let state = store.getState()
    return state.project.location
  }
  let location = window.localStorage.getItem('peikko-dbs-location')
  if (location) {
    return location
  }

  return ''
}

export const getSpaceType = (location: string, spaceType: string) => {
  if (location === 'US' || location === 'CA') {
    return 'C1'
  }

  return spaceType
}

export const getDefaultSpaceType = (location: string) => {
  if (location === 'US' || location === 'CA') {
    return 'C1'
  }

  return 'A'
}

export const isLocationNorthAmerica = () => {
  let location = getLocation()

  if (location === 'US' || location === 'CA') {
    return true
  }
  return false
}

const isLocationUS = () => {
  let location = getLocation()
  if (location === 'US') {
    return true
  }
  return false
}

const isLocationCA = () => {
  let location = getLocation()
  if (location === 'CA') {
    return true
  }
  return false
}

export const getRedirectAfterLocationSelect = (): string => {
  if (isLocationNorthAmerica()) {
    return '/project/new/workspace'
  }

  return '/spacetype'
}

const inchFormatter = (value: number, makeRound: boolean = true) => {
  var result = value / 10 / 2.54
  return Number(result.toFixed(makeRound ? 0 : 2))
}

const mmFormatter = (value: number) => {
  return Math.round(value)
}

export const formatMm = (value: number, makeRound: boolean = true): number => {
  if (isLocationUS()) {
    return inchFormatter(value, makeRound)
  }

  return mmFormatter(value)
}

export const unitConversion = (unit: string) => {
  if (isLocationUS() && unit === 'mm') {
    return 'inch'
  }
  if (isLocationUS() && unit === 'kN/m2') {
    unit = 'psf'
  }
  if (isLocationCA() && unit === 'kN/m2') {
    unit = 'kPa'
  }
  if (isLocationUS() && unit === 'kN/m') {
    unit = 'kips/ft'
  }
  if (isLocationUS() && unit === 'kNm') {
    unit = 'kip/ft'
  }
  if (isLocationUS() && unit === 'kN') {
    unit = 'kip'
  }
  if (isLocationUS() && unit === 'kg') {
    unit = 'lbs'
  }
  if (isLocationUS() && unit === 'm') {
    unit = 'ft'
  }

  return unit
}

export const unitConfigConversion = (config: UnitConfig) => {
  config.unit = unitConversion(config.unit)

  return config
}

export const parseMm = (value: string) => {
  const parsedValue = intParser(value) === null ? 0 : intParser(value)

  if (isLocationUS()) {
    return Math.round(parsedValue! * 10 * 2.54)
  }

  return parsedValue
}

export const parseKNm2 = (value: string) => {
  if (isLocationUS()) {
    return parseFloat(value) * 0.047880258888889
  }

  return value
}

const round = (inputValue, precision) => {
  let pair = (inputValue + 'e').split('e')
  let value = Math.round(parseFloat(pair[0] + 'e' + (+pair[1] + precision)))
  pair = (value + 'e').split('e')
  return +(pair[0] + 'e' + (+pair[1] - precision))
}

export const formatKNm2 = (value: number) => {
  if (isLocationUS()) {
    return round(value / 0.047880258888889, 0)
  }

  return round(value, 2)
}

// kN/m
export const _parseKNm = (value: string) => {
  if (isLocationUS()) {
    return parseFloat(value) / 0.0685218
  }

  return value
}

// kN/m
export const _formatKNm = (value: number) => {
  if (isLocationUS()) {
    return round(value * 0.0685218, 2)
  }

  return round(value, 2)
}

// kNm
export const parseKNm = (value: string) => {
  if (isLocationUS()) {
    return parseFloat(value) / 0.737562
  }

  return value
}

// kNm
export const formatKNm = (value: number) => {
  if (isLocationUS()) {
    return round(value * 0.737562, 2)
  }

  return round(value, 2)
}

export const formatKg = (value: number) => {
  if (isLocationUS()) {
    return round(value * 2.2046, 2)
  }

  return round(value, 2)
}

export const formatKgPerM2 = (value: number) => {
  if (isLocationUS()) {
    return round(value * 0.204816, 2)
  }

  return round(value, 2)
}

export const parseKN = (value: string) => {
  if (isLocationUS()) {
    return parseFloat(value) / 0.224809
  }

  return value
}

export const formatKN = (value: number) => {
  if (isLocationUS()) {
    return round(value * 0.224809, 2)
  }

  return value
}

export const showSpaceType = () => {
  if (isLocationNorthAmerica()) {
    return false
  }

  return true
}

export const convertSlabModels = (model: string) => {
  if (isLocationNorthAmerica()) {
    if (model === 'HC18') {
      return "7''"
    }
    if (model === 'HC20') {
      return "8''"
    }
    if (model === 'HC27') {
      return "10''"
    }
    if (model === 'HC32') {
      return "12''"
    }
    if (model === 'HC37') {
      return "14''"
    }
    if (model === 'HC40') {
      return "16''"
    }
  }

  return model
}

export const convertFireResistance = (value: string) => {
  if (isLocationNorthAmerica()) {
    if (value === 'R15') {
      return '0.15 HR'
    }
    if (value === 'R30') {
      return '0.5 HR'
    }
    if (value === 'R45') {
      return '0.75 HR'
    }
    if (value === 'R60') {
      return '1 HR'
    }
    if (value === 'R90') {
      return '1.5 HR'
    }
    if (value === 'R120') {
      return '2 HR'
    }
    if (value === 'R150') {
      return '2.5 HR'
    }
    if (value === 'R180') {
      return '3 HR'
    }
  }

  return value
}

export const filterFireResistance = grades => {
  if (isLocationNorthAmerica()) {
    let filtered = ['R60', 'R120', 'R180']
    grades = grades.filter(g => filtered.includes(g.id))
  }

  return grades
}

export const convertConcreteGrades = (value: string) => {
  if (isLocationUS()) {
    if (value === 'Infill concrete C20/25') {
      return 'Infill concrete 3,000psi'
    }
    if (value === 'Infill concrete C25/30') {
      return 'Infill concrete 3,500psi'
    }
    if (value === 'Infill concrete C28/35') {
      return 'Infill concrete 4,000psi'
    }
    if (value === 'Infill concrete C30/37') {
      return 'Infill concrete 4,500psi'
    }
    if (value === 'Infill concrete C35/45') {
      return 'Infill concrete 5,000psi'
    }
    if (value === 'Infill concrete C40/50') {
      return 'Infill concrete 6,000psi'
    }
    if (value === 'Infill concrete C50/60') {
      return 'Infill concrete 7,000psi'
    }
  }
  if (isLocationCA()) {
    if (value === 'Infill concrete C20/25') {
      return 'Infill concrete 20MPa'
    }
    if (value === 'Infill concrete C25/30') {
      return 'Infill concrete 25MPa'
    }
    if (value === 'Infill concrete C30/37') {
      return 'Infill concrete 30MPa'
    }
    if (value === 'Infill concrete C35/45') {
      return 'Infill concrete 35MPa'
    }
    if (value === 'Infill concrete C40/50') {
      return 'Infill concrete 40MPa'
    }
    if (value === 'Infill concrete C45/55') {
      return 'Infill concrete 45MPa'
    }
    if (value === 'Infill concrete C50/60') {
      return 'Infill concrete 50MPa'
    }
  }

  return value
}

export const filterSlabModels = (slabTypes, selectedType) => {
  let types = slabTypes.filter(st => st.type === selectedType)

  if (isLocationNorthAmerica()) {
    let filtered = ['HC50']
    types = slabTypes.filter(st => !filtered.includes(st.model))
  }

  return types
}

export const filterConcreteGrades = grades => {
  if (isLocationUS()) {
    let filtered = [
      'C20/25',
      'C25/30',
      'C28/35',
      'C30/37',
      'C35/45',
      'C40/50',
      'C50/60'
    ]
    grades = grades.filter(g => filtered.includes(g.id))
  }

  if (isLocationCA()) {
    let filtered = [
      'C20/25',
      'C25/30',
      'C30/37',
      'C45/55',
      'C35/45',
      'C40/50',
      'C50/60'
    ]
    grades = grades.filter(g => filtered.includes(g.id))
  }

  return grades
}

let beamProfiles = new Map([
  ['D20-300', 'IDB8-20'],
  ['D20-400', 'IDB8-24'],
  ['D20-500', 'IDB8-30'],
  ['D25-300', 'IDB10-20'],
  ['D25-400', 'IDB10-24'],
  ['D25-500', 'IDB10-30'],
  ['D30-300', 'IDB12-20'],
  ['D30-400', 'IDB12-24'],
  ['D30-500', 'IDB12-30'],
  ['D35-400', 'IDB14-24'],
  ['D35-500', 'IDB14-30'],
  ['D40-400', 'IDB16-24'],
  ['D40-500', 'IDB16-30'],
  ['D40-600', 'IDB16-34'],
  ['D50-500', 'IDB20-30'],
  ['D50-600', 'IDB20-34'],
  ['D50-700', 'IDB20-38'],
  ['D60-600', 'IDB24-34'],
  ['D60-700', 'IDB24-38'],
  ['D65-800', 'IDB26-42'],
  ['D70-800', 'IDB28-42'],
  ['DR20-215', 'EDB8-15'],
  ['DR25-260', 'EDB10-15'],
  ['DR30-270', 'EDB12-15'],
  ['DR40-295', 'EDB16-20'],
  ['DR50-350', 'EDB20-24'],
  ['DR60-500', 'EDB24-30']
])

export const convertBeamProfile = (value: string) => {
  if (isLocationNorthAmerica() && beamProfiles.has(value)) {
    return beamProfiles.get(value)
  }

  return value
}

export const convertBeamMaterial = (value: string) => {
  if (isLocationUS()) {
    return 'ASTM A572 GR50'
  }
  if (isLocationCA()) {
    return 'G40.21 350W'
  }

  return value
}

export const convertBeamExtra = (value: string) => {
  if (isLocationUS()) {
    return 'ASTM A605 GR60'
  }
  if (isLocationCA()) {
    return 'G30.18 400W'
  }

  return value
}

const getLoadName = (name: string) => {
  if (name === 'Permanent') {
    name = 'SuperImposed Dead Load'
  }
  if (name === 'Temporary (automatic)') {
    name = 'Construction Live Load (automatic)'
  }
  if (name === 'Variable load') {
    name = 'Live Load'
  }
  return name
}

export const convertDefaultLoadNames = loads => {
  if (isLocationNorthAmerica()) {
    loads = loads.map(load => {
      return { ...load, name: getLoadName(load.name) }
    })
  }

  return loads
}

export const convertCurrencySign = (sign: string): string => {
  if (isLocationNorthAmerica() && sign === '€') {
    return '$'
  }
  if (sign === 'CO2') {
    return 'CO2e'
  }
  return sign
}

export const convertTooltip = (tooltip: string) => {
  if (isLocationNorthAmerica()) {
    if (tooltip === tooltips.slabweight) {
      return 'The weight depends on slab type and model.'
    }
    if (tooltip === tooltips.slabspan) {
      return (
        'Slab span minimum is ' +
        formatMm(1000) +
        ' ' +
        unitConversion('mm') +
        '. With shorter spans remove the slab and substitute it with relevant in-situ concrete related loading.'
      )
    }
  }
  return tooltip
}



// WEBPACK FOOTER //
// ./src/location_changes/conversionHelper.tsx